import { Injectable } from '@angular/core';
import { ButtonEvent, ButtonsConfig, ButtonsStrategy, ButtonType, Description, DescriptionStrategy, Image } from '@ks89/angular-modal-gallery';
import * as printJS from 'print-js';

export class PosicaoImagem {
    maxY: number;
    minY: number;
    maxX: number;
    minX: number;

    constructor(init: Partial<PosicaoImagem>) {
        Object.assign(this, init);
    }
}

@Injectable()
export class KsModalGalleryConfiguration {

    private minMaxHeight: number = 60;
    private minMaxWidth: number = 100;

    images = [new Image(0, { img: '' })];

    buttonsConfigCustom: ButtonsConfig = {
        visible: true,
        strategy: ButtonsStrategy.CUSTOM,
        buttons: [
            {
                className: 'print white printer',
                type: ButtonType.CUSTOM,
                ariaLabel: 'Imprimir',
                title: 'Imprimir',
                fontSize: '30px',
            },
            {
                className: 'zoom_out white zoom-out',
                type: ButtonType.CUSTOM,
                ariaLabel: 'Reduzir',
                title: 'Reduzir',
                fontSize: '30px',
            },
            {
                className: 'zoom_in white zoom-in',
                type: ButtonType.CUSTOM,
                ariaLabel: 'Ampliar',
                title: 'Ampliar',
                fontSize: '30px',
            },
            {
                className: 'download white',
                type: ButtonType.DOWNLOAD,
                ariaLabel: 'Download',
                title: 'Download',
                fontSize: '30px'
            },
            {
                className: 'close-item white',
                type: ButtonType.CLOSE,
                ariaLabel: 'Fechar',
                title: 'Fechar',
                fontSize: '30px'
            },
        ]
    };

    customDescription: Description = {
        strategy: DescriptionStrategy.ALWAYS_HIDDEN
    };
    
    onButtonBeforeHook(event: ButtonEvent, posicao: PosicaoImagem) {

        if (event.button.type === ButtonType.CUSTOM && event.button.className.includes('zoom-in')) {

            let element = document.getElementById('current-image');
            if (!element.style['max-height']) {
                element.style['max-height'] = this.minMaxHeight + 'vh';
                element.style['max-width'] = this.minMaxWidth + '%';
            }

            const widthAntigo = element['width'];
            let maxHeightValue = parseFloat(element.style['max-height'].replace('vh', ''));
            let maxWidthValue = parseFloat(element.style['max-width'].replace('%', ''));       
            element.style['max-height'] = (maxHeightValue + 10) + 'vh';
            element.style['max-width'] = (maxWidthValue + 10) + '%';
            element.style['min-height'] = (maxHeightValue + 10) + 'vh';
            this.atualizarPosicaoImagem(posicao);
            const novoWidth = element['width'];

            document.getElementById('current-figure').style['min-width'] = (element['width'] + 120) + 'px'; //120 representa o margin-left + right;
            document.getElementById('flex-min-height-ie-fix').style['min-width'] = (element['width'] + 120) + 'px'; //120 representa o margin-left + right;

            if (novoWidth == widthAntigo) {
                abp.notify.error('O zoom já está no limite, não sendo possível ampliar mais!');
                element.style['max-height'] = maxHeightValue + 'vh';
                element.style['max-width'] = maxWidthValue + '%';
            }

        }

        if (event.button.type === ButtonType.CUSTOM && event.button.className.includes('zoom-out')) {

            let element = document.getElementById('current-image');
            if (!element.style['max-height']) {
                element.style['max-height'] = this.minMaxHeight + 'vh';
                element.style['max-width'] = this.minMaxWidth + '%';
            }

            let maxHeightValue = parseFloat(element.style['max-height'].replace('vh', ''));
            let maxWidthValue = parseFloat(element.style['max-width'].replace('%', ''));  
            
            if (maxHeightValue != 10) {
                element.style['max-height'] = (maxHeightValue - 10) + 'vh';
                element.style['max-width'] = (maxWidthValue - 10) + '%';
                element.style['min-height'] = (maxHeightValue - 10) + 'vh';     

                document.getElementById('current-figure').style['min-width'] = (element['width'] + 120) + 'px'; //120 representa o margin-left + right;
                document.getElementById('flex-min-height-ie-fix').style['min-width'] = (element['width'] + 120) + 'px'; //120 representa o margin-left + right;
    
                this.atualizarPosicaoImagem(posicao);
            } else {
                abp.notify.error('O zoom já está no limite, não sendo possível reduzir mais!');
            }
        }

        if (event.button.type === ButtonType.CUSTOM && event.button.className.includes('printer')) {
            printJS({
                printable: event.image.modal.img,
                type: 'image',
                showModal: false,
                style: 'img { max-width: 800px;max-height: 800px;}'
            });
        }

        if(event.button.type === ButtonType.DOWNLOAD) {
            const link = document.createElement('a');
            link.href = <string>event.image.modal.img;
            link.setAttribute('download', <string>event.image.modal.downloadFileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

    }

    atualizarPosicaoImagem(posicao: PosicaoImagem) {
        const posicaoImagem = document.getElementById('current-image').getBoundingClientRect();
        posicao.maxY = posicaoImagem.top + posicaoImagem.height;
        posicao.maxX = posicaoImagem.left + posicaoImagem.width;
        posicao.minY = posicaoImagem.top;
        posicao.minX = posicaoImagem.left;
    }

    configurarDragImagem(posicao: PosicaoImagem) {
        const slider = document.getElementById('modal-gallery-wrapper');
        const image = document.getElementById('current-image');
        let mouseDown = false;
        let startY, scrollTop, scrollLeft, startX;
        let posicaoImagem = posicao;

        let startDragging = function (e) {
            if (e.pageY >= posicaoImagem.minY && e.pageY <= posicaoImagem.maxY && e.pageX >= posicaoImagem.minX && e.pageX <= posicaoImagem.maxX) {
                mouseDown = true;
                startY = e.pageY - slider['offsetTop'];
                startX = e.pageX - slider['offsetLeft'];
                scrollTop = slider.scrollTop;
                scrollLeft = slider.scrollLeft;
                image.classList.add('active');
            }
        };

        let stopDragging = function (event) {
            mouseDown = false;
            image.classList.remove('active');
        };

        slider.addEventListener('mousemove', (e) => {
            e.preventDefault();
            if (!mouseDown) { return; }
            const y = e['pageY'] - slider['offsetTop'];
            const scrollTopInner = y - startY;
            const x = e['pageX'] - slider['offsetLeft'];
            const scrollLeftInner = x - startX;
            slider.scrollTop = scrollTop - scrollTopInner;
            slider.scrollLeft = scrollLeft - scrollLeftInner;
        });

        slider.addEventListener('mousedown', startDragging, false);
        slider.addEventListener('mouseup', stopDragging, false);
        slider.addEventListener('mouseleave', stopDragging, false);
    }

}
